import React, { FC } from 'react';
import { Tooltip } from '@grow-components/Tooltip/Tooltip';
import { Icon } from '@grow-components/Icon/Icon';
import commonStyles from '@grow-components/Form/CommonStyles.module.scss';
import { cn } from 'utils';

type TIconWithToolTipProps = {
  text: string | JSX.Element
  color?: string
  icon: string
  iconPrefix?: string
  iconClassname?: string
  className?: string
}
export const IconWithToolTip: FC<TIconWithToolTipProps> = (props) => {
  const { text, icon, iconPrefix } = props;
  return (
    <Tooltip text={text} className={props.className}>
      <Icon icon={icon} iconPrefix={iconPrefix} className={props.iconClassname} />
    </Tooltip>
  );
};

type TWarningIconProps = {
  text: string | JSX.Element
  className?: string
}
export const WarningIcon: FC<TWarningIconProps> = (props) => (
  <IconWithToolTip
    icon="triangle-exclamation"
    className={cn(commonStyles.warningIcon, props.className)}
    text={props.text}
  />
);
